<style>
#servitudeCardModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 460px !important;
}
#servitudeCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#servitudeCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#servitudeCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
</style>

<template>
  <Modal
    modalName="servitudeCardModal"
    @closed="closed()"
    @editingCancel="cancelEditing()"
    @editingSave="saveEditing()"
    @editingStart="startEditing()"
    @opened="getServitudeData(), updateList(), loadDict()"
    @print="print()"
    @zoom="zoomToParcel()"
    :buttons="['print', 'zoom']"
    :editing="editing"
    :module="module"
    :title="`KARTA SŁUŻEBNOŚCI O ID ${servitudeData.id}`"
  >
    <v-tabs
      color="#2a579a"
      dark
      centered
      grow
      active-class="tab--active"
      :hide-slider="true"
      height="35"
      v-if="!!servitudeData.id"
    >
      <v-tab>ATRYBUTY</v-tab>
      <v-tab-item>
        <v-card
          flat
          id="attr__wrapper"
        >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>PODSTAWOWE INFORMACJE O SŁUŻEBNOŚCI</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-select
                  :items="statuses"
                  v-model="servitudeData.status"
                  label="Status"
                  required
                  :rules="required"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Data ustanowienia"
                      prepend-icon="event"
                      @input="servitudeData.date = parseDate(computedDateFormatted)"
                      v-on="on"
                      required
                      :rules="required"
                      :readonly="!editing"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="servitudeData.date"
                    @input="dateMenu = false"
                    color="#2a579a"
                    no-title
                    required
                    :rules="required"
                    :readonly="!editing"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Numer księgi wieczystej"
                  v-model="servitudeData.register_number"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  label="Numer repertorium"
                  v-model="servitudeData.repertory_number"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Szerokość pasa gruntu obciążonego służebnością"
                  v-model="servitudeData.width"
                  type="number"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>INFORMACJE O LOKALIZACJI</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Adres"
                  v-model="servitudeData.parcel_address"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  label="Teryt"
                  v-model="servitudeData.parcel"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Obręb"
                  v-model="servitudeData.precinct_name"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>INFORMACJE O WŁAŚCICIELU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Adres"
                  v-model="servitudeData.address"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="ownerTypes"
                  v-model="servitudeData.owner_type"
                  label="Typ właściciela"
                  required
                  :rules="required"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  label="Kontakt"
                  v-model="servitudeData.contact"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  label="Właściciel"
                  v-model="servitudeData.owner"
                  required
                  :rules="required"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-text-field
                  label="Opis"
                  v-model="servitudeData.description"
                  :readonly="!editing"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-tab-item>

      <v-tab>POWIĄZANE OBIEKTY</v-tab>
      <v-tab-item>
        <v-layout
          row
          wrap
          v-if="editing"
        >
          <v-flex xs12>
            <v-subheader>DODAWANIE OBIEKTÓW</v-subheader>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="editing"
        >
          <v-flex xs12>
            <v-btn
              small
              dark
              depressed
              color="#2a579a"
              style="margin-left: 0;"
              @click="selectNewObject"
            >WSKAŻ OBIEKT NA MAPIE</v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-list
            subheader
            style="width: 100%"
            v-if="objects.length != 0"
          >
            <v-subheader>POWIĄZANE ELEMENTY</v-subheader>
            <v-list-tile
              v-for="(object, index) in objects"
              :item="object"
              :key="object.object_id"
              style="border-bottom: 1px solid lightgrey"
            >
              <v-list-tile-content>
                <v-list-tile-title class="font--primary">Obiekt '{{object.full_name}}' - {{object.object_display_id}}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <span>
                  <v-icon
                    depressed
                    fab
                    id="btn__hydrant--zoom"
                    class="hydrant__icon"
                    @click="zoomToObject(object, index)"
                    title="Przybliż do obiektu"
                  >zoom_in</v-icon>
                  <v-icon
                    depressed
                    fab
                    class="hydrant__icon"
                    id="btn__hydrant--remove"
                    v-if="editing"
                    @click="removeObject(object, index)"
                    title="Usuń obiekt"
                  >delete</v-icon>
                </span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-flex v-else>
            <v-subheader>POWIĄZANE ELEMENTY</v-subheader>
            <p
              v-if="objects.length == 0"
              style="font-size: 12px; margin-bottom:20px"
            >Brak zaznaczonych obiektów. Kliknij przycisk powyżej, a następnie wskaż na mapie obiekt, do którego chciałbyś dodać załącznik.</p>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-subheader>DŁUGOŚĆ I POWIERZCHNIA POWIĄZANYCH ELEMENTÓW</v-subheader>
          </v-flex>
          <v-flex
            xs12
            v-if="objects.length == 0"
          >
            <p>Brak powiązanych elementów</p>
          </v-flex>
          <template v-else>
            <v-flex xs12>
              <p v-for="(length, table) in lengthSum">
                <span v-if="table == 'pipes'">Sumaryczna długość przewodów wodociągowych: {{length.toFixed(2)}} m</span>
                <span v-else-if="table == 'pipes_sewers'">Sumaryczna długość przewodów kanalizacyjnych: {{length.toFixed(2)}} m</span>
              </p>
            </v-flex>
            <v-flex xs12>
              <p>Powierzchnia części nieruchomości obciążona służebnością przesyłu: {{areaSum.toFixed(2)}} m<sup>2</sup></p>
            </v-flex>
          </template>
        </v-layout>
      </v-tab-item>

      <v-tab v-if="featureEvents != undefined && featureEvents.hasOwnProperty('events')">ZDARZENIA ({{featureEvents.events_count}})</v-tab>
      <v-tab v-else>ZDARZENIA (0)</v-tab>
      <v-tab-item>
        <v-card flat>
          <Events
            style="margin-top: 15px"
            :featureEvents="featureEvents"
            :objectType="objectType"
            :id="servitudeData.id"
            :module="module"
          />
        </v-card>
      </v-tab-item>

      <v-tab v-if="attachmentsArr.hasOwnProperty('data')">ZAŁĄCZNIKI ({{attachmentsArr.data.length}})</v-tab>
      <v-tab-item>
        <v-layout row>
          <v-flex
            xs12
            v-if="$can('read', 'transmission_easement_attachments') || $can('edit', 'transmission_easement_attachments')"
          >
            <v-subheader class="font--primary">POWIĄZANE ZAŁĄCZNIKI</v-subheader>
            <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
              <li
                class="list__container--el"
                v-for="(index, key) in attachmentsArr.data"
                :key="key"
              >
                <span>{{index.id}} - {{index.filename}}</span>
                <span>
                  <v-icon
                    @click="downloadAttachment(index.id, index.filename)"
                    small
                    title="Pobierz załącznik"
                    v-if="$can('read', 'transmission_easement_attachments') || $can('edit', 'transmission_easement_attachments')"
                  >cloud_download</v-icon>
                  <v-icon
                    @click="deleteAttachment(index.id)"
                    small
                    title="Usuń załącznik"
                    v-if="$can('edit', 'transmission_easement_attachments')"
                  >delete</v-icon>
                </span>
              </li>
            </div>
            <div v-else>
              <p class="font--primary">Brak powiązanych załączników</p>
            </div>
            <AddAttachment
              ref="childComponent"
              v-show="editing"
              @attachmentAdded="updateList"
              @attachmentDeleted="updateList"
              @confDialogOpened="triggerDialogAttach"
              :auto="true"
              :id_="servitudeData.id"
              :objectType="objectType"
              :module="module"
            />
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-show="editing"
        >
          <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
        </v-layout>
        <v-layout
          row
          wrap
          style="height: 90%"
          v-show="editing"
        >
          <v-flex xs12>
            <DatabaseAttachments
              :objectIdCard="servitudeData.id"
              :objectTableCard="objectTable"
              :objectTypeCard="objectType"
              @attachmentAdded="updateList"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>

    </v-tabs>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import DatabaseAttachments from "../../table/attachments/DatabaseAttachments";
import Events from "../../../shared/Events";
import Modal from "../../../shared/Modal";

import {getArea, getLength} from "ol/sphere.js";
import {
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";
import {GeoJSON} from "ol/format";
import {Vector as VectorLayer} from "ol/layer";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import includes from "lodash/includes";
import map from "lodash/map";
import each from "lodash/each";
import some from "lodash/some";
import find from "lodash/find";
import filter from "lodash/filter";
import sumBy from "lodash/sumBy";
import clone from "lodash/clone";
import defaults from "lodash/defaults";
import groupBy from "lodash/groupBy";
import mapValues from "lodash/mapValues";
mixin(_, {
  includes,
  map,
  some,
  find,
  each,
  filter,
  chain,
  sumBy,
  clone,
  defaults,
  groupBy,
  mapValues
});
_.value = value;
_.prototype.value = value;


import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {
  Coordinate,
  Geometry as jstsGeometry,
  GeometryFactory
} from "jsts/org/locationtech/jts/geom";
import {BufferOp} from "jsts/org/locationtech/jts/operation/buffer";
import {RelateOp} from "jsts/org/locationtech/jts/operation/relate";
import {OverlayOp} from "jsts/org/locationtech/jts/operation/overlay";

//<editor-fold defaultstate="collapsed" desc="config jsts geometry">
const ol_parser = new OL3Parser();
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);
jstsGeometry.prototype.buffer = function () {
  return BufferOp.bufferOp(this, ...arguments);
};
jstsGeometry.prototype.intersects = function () {
  return RelateOp.intersects(this, ...arguments);
};
jstsGeometry.prototype.contains = function () {
  return RelateOp.contains(this, ...arguments);
};
jstsGeometry.prototype.intersection = function (other) {
  return OverlayOp.intersection(this, other);
};

const fabryka = new GeometryFactory();
//</editor-fold>

export default {
  components: {
    Modal,
    AddAttachment,
    DatabaseAttachments,
    Events
  },
  data: () => ({
    // RULES
    valid: false,
    required: [v => !!v || "Pole wymagane"],

    //słowniki
    statuses: [],
    ownerTypes: [],

    editing: false,
    objectType: "transmission_easement",
    attachmentsArr: [],
    module: "transmission_easement",

    servitudeData: {},
    servitudeDataCopy: undefined,

    connectedElements: [],
    dateMenu: false,
    objects: [],
    objectsCopy: undefined,
  }),
  computed: {
    computedDateFormatted() {
      if(this.servitudeData.date) {
        return this.formatDate(this.servitudeData.date.slice(0, 10));
      } else {
        return this.formatDate(`2019-01-01`);
      }
    },

    map() {
      return this.$store.getters.getMap;
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
    wodkanLayers() {
      return this.$store.getters.getLayers;
    },
    geoportalName() {
      return this.$store.getters.getAquagisName;
    },
    styles() {
      return this.$store.getters.getStyles;
    },
    labelsShow() {
      return this.$store.getters.getLabelsShow;
    },

    areaSum() {
      return _.sumBy(this.objects, (object) => object.length * 2); // Domyślna szerokość służebności - 2m
    },
    lengthSum() {
      return _(this.objects)
        .groupBy('object_table')
        .mapValues((objects, object_table) => _.sumBy(objects, 'length'))
        .value();
    },

    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
  },
  watch: {
    'servitudeData.date'(val) {
      this.date = this.formatDate(this.servitudeData.date);
    },
    objects(_new) {
      this._computedWatchers.areaSum.update();
      this._computedWatchers.lengthSum.update();
      this.$forceUpdate();
    }
  },
  methods: {
    closed() {
      this.editing = false;
      this.$store.commit("setServitudeData", undefined);

      this.map.getViewport().style.cursor = "";
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.objects = [];
      this.objectsCopy = undefined;

      this.$root.$emit('toggleLayer', `app_layer_${this.geoportalName}:granice_dzialek`, false);
    },

    cancelEditing() {
      this.servitudeData = this.servitudeDataCopy;
      this.objects = _.clone(this.objectsCopy);
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      _.each(this.objects, (object) => {
        this.$store.commit("addCurrentSelectedFeatures", [object.org_feature]); //dodanie do listy zaznaczonych
        this.selectedLayer.getSource().addFeature(object.org_feature.__value); //dodanie podświetlania
      });
      this.editing = false;
    },
    saveEditing() {
      const self = this;

      const payload = _.clone(self.servitudeData);
      payload.objects = _.map(self.objects, (object) => ({
        object_id: object.object_id,
        object_table: object.object_table,
        object_type: "layers",
        area: object.length * 2,
        length: object.length,
      }));
      delete payload.id;
      delete payload.geometry;
      delete payload.attachments;

      if(this.$refs.form.validate()) {
        fetch(`${self.$store.getters.getApiURL}/transmission-easement/${self.servitudeData.id}?token=${self.$store.getters.getToken}`, {
          method: 'PUT',
          body: JSON.stringify(payload)
        })
          .then(response =>
            response.status === 200
              ? response.json().then((data) => [response.status, data])
              : response.text().then((data) => [response.status, data])
          )
          .then(([status, data]) => {
            if(status === 200) {
              self.$root.$emit("showSnackbar", "success", "Zmodyfikowano");
              self.servitudeDataCopy = undefined;
              self.editing = false;
            } else {
              self.$root.$emit("showSnackbar", "orange", data);
            }
          })
          .catch(error => {
            self.$root.$emit("showSnackbar", "red", error);
          });
      }
    },
    startEditing() {
      this.servitudeDataCopy = JSON.parse(JSON.stringify(this.servitudeData));
      this.objectsCopy = _.clone(this.objects);
      this.editing = true;
    },

    getServitudeData() {
      const self = this;

      self.servitudeData = self.$store.getters.getServitudeData.transmission_easement;
      self.servitudeData.date = self.servitudeData.date.slice(0, 10);

      self.objects = self.servitudeData.objects || [];
      delete self.servitudeData.objects;

      //zaczytanie powiązanych feature
      _.each(self.objects, (object) => {
        self.$store.dispatch("getFeature", {
          object_table: object.object_table,
          object_id: object.object_id,
          object_type: "layers",
          srid: this.$root.projection
        }).then((feature) => {
          object.org_feature = self.$root.createProxy(feature);

          const layer = _.find(self.wodkanLayers, (layer) => layer.type === object.object_table);
          object.full_name = layer.full_name || object.object_table;
          object.object_display_id = feature.getId();

          self.$store.commit("addCurrentSelectedFeatures", [object.org_feature]); //dodanie do listy zaznaczonych
          self.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
        });
      });

      self.$root.$emit('toggleLayer', `app_layer_${self.geoportalName}:granice_dzialek`, true);

      self.dzialkaGeometry = new GeoJSON().readGeometryFromObject(self.servitudeData.geometry);
    },
    updateList() {
      if(this.servitudeData != undefined) {
        const payload = {
          object_type: this.objectType,
          //layer: this.objectTable,
          oid: this.servitudeData.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if(success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }
    },
    loadDict() {
      const payload = {
        schema: "registry",
        table: "transmission_easement"
      };
      this.$store.dispatch('getDictSTC', _.defaults({
        column: "status"
      }, payload)).then(r => {
        this.statuses = r.values;
      });
      this.$store.dispatch('getDictSTC', _.defaults({
        column: "owner_type"
      }, payload)).then(r => {
        this.ownerTypes = r.values;
      });
    },
    print() {
      const self = this;

      let payload = {
        layers: {
          app_layers: [
            "granice_dzialek"
          ],
          basemap: self.$store.getters.getCurrentBasemap,
          system_layers: []
        },
        oid: self.servitudeData.id
      };

      let availableLayers = [
        "pipes",
        "pipes_sewers"
      ];
      const layersArray = self.map.getLayers().getArray();
      layersArray[2].getLayers().forEach(layer => { //tylko warstwy danych
        const type = layer.get('type');
        if(layer instanceof VectorLayer && layer.getVisible() && availableLayers.includes(type)) {
          const full_type = layer.get('full_type');
          const net_type = layer.get('net_type');

          let temp_layer = {
            name: layer.get('full_type')
          };
          if(net_type) {
            temp_layer.style = self.styles.layers[type][net_type];
          } else {
            temp_layer.style = self.styles.layers[full_type];
          }

          if(self.labelsShow) {
            temp_layer.label_fields = temp_layer.style.labels;
          }
          payload.layers.system_layers.push(temp_layer);
          temp_layer = null;
        }
      });


      if(payload.layers.basemap === `${self.geoportalName}:mapa_zasadnicza`) {
        payload.layers.basemap = "mapa zasadnicza";
      } else if(payload.layers.basemap === "Brak") {
        payload.layers.basemap = "";
      }

      self.$store.dispatch("servitudeReport", payload)
        .then(r => {
          if(r.status === 200) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              "Pomyślnie utworzono raport"
            );
          } else {
            this.$root.$emit("showSnackbar", "red", `${r}`);
          }
        });
    },
    zoomToParcel() {
      this.$root.$emit('zoomToGeometry', this.dzialkaGeometry); //jest w 2180
    },

    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },

    formatDate(date) {
      if(!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if(!date) return null;

      const [day, month, year] = date.split('-');
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
    },

    selectNewObject() {
      const self = this;

      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";
      const geomDzialka = ol_parser.read(self.dzialkaGeometry);

      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          const features = featuresLayer.features_cluster.length > 0
            ? featuresLayer.features_cluster
            : featuresLayer.features;
          _.each(features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();

            if(_.some(self.objects, object => object.object_id === id)) {
              return; //duplicat
            }

            const geomObject = ol_parser.read(feature.getGeometry());
            if(geomObject.intersects(geomDzialka)) {
              const geom = ol_parser.write(geomObject.intersection(geomDzialka));
              const org_feature = self.$root.createProxy(feature);

              self.objects.push({
                object_id: feature.getId(),
                object_table: featuresLayer.layer.get("type"),
                object_type: "layers",
                full_name: featuresLayer.layer.get("full_name"),
                object_display_id: feature.getId(),

                length: getLength(geom),
                org_feature, //orginalny feature do usuwania i zoomu
              });

              self.$store.commit("addCurrentSelectedFeatures", [org_feature]); //dodanie do listy zaznaczonych
              self.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
            } else {
              self.$root.$emit(
                "showSnackbar",
                "orange",
                "Obiekt poza działką"
              );
            }
          });
        });
        self.$forceUpdate();
        self.map.getViewport().style.cursor = "";
      });
      self.$root.$emit("enableSelectionElement", {
        layers: ["pipes", "pipes_sewers"],
        selected: false,
        multi: false
      });
    },
    removeObject(object, index) {
      this.objects.splice(index, 1);

      this.$store.commit("removeCurrentSelectedFeatures", [object.org_feature]); //usunięcie z listy zaznaczonych
      this.selectedLayer.getSource().removeFeature(object.org_feature.__value); //usunięcie podświetlania
    },
    zoomToObject(object, index) {
      this.$root.$emit("zoomToFeature", object.org_feature.__value, {});
    },
  },
  mounted() {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/modals/ServitudeCard.vue